import { IntegrationSyncSelectOption, SingleSelectInput } from "components";
import { observer } from "mobx-react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import React, { FC, useCallback } from "react";
import { TAltoSyncLeadSourceExtendedData } from "types/alto.type";
import { IntegrationEntitySyncStatusEnum } from "enums/integration-entity-sync-status.enum";
import { TSelectValue } from "types/select-input.type";

interface IProps {
  accountStore: UserAccountStore;
  record: TAltoSyncLeadSourceExtendedData;
  onChange: (syncPair: TAltoSyncLeadSourceExtendedData) => void;
}

export const AltoLeadSourceSyncSelect: FC<IProps> = observer(
  ({ accountStore, record, onChange }) => {
    const options =
      accountStore.accountIntegrationsStore.accountIntegrationAltoStore
        .accountIntegrationAltoLeadSourcesStore.altoLeadSourcesOptions;

    const handleChange = useCallback(
      (altoId: TSelectValue<string>) => {
        onChange({
          altoId: altoId || null,
          leadSourceId: record.leadSourceId,
          leadSourceName: record.leadSourceName,
          syncStatus: IntegrationEntitySyncStatusEnum.NOT_SYNCED,
        });
      },
      [onChange, record]
    );

    return (
      <SingleSelectInput
        value={record.altoId}
        clearable={true}
        options={options}
        onChange={handleChange}
        optionComponent={optionProps => (
          <IntegrationSyncSelectOption optionProps={optionProps} />
        )}
      />
    );
  }
);
